import DocumentSearchIcon from '@flipster/react/icon/generated/DocumentSearchIcon';
import { css, cx } from '@flipster/styled-system/css';
import { vstack } from '@flipster/styled-system/patterns';

interface Props {
  title: string;
  description?: string;
  className?: string;
}

export const NoFeedYet = ({ title, description, className }: Props) => {
  return (
    <div className={cx(vstack({ gap: 4, p: 24 }), className)}>
      <DocumentSearchIcon size={24} />
      <p className={css({ textStyle: 'Text/L/Strong', color: 'content.default.level-5' })}>{title}</p>
      {description && (
        <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-1' })}>{description}</p>
      )}
    </div>
  );
};
